
import _ from "lodash";
import Guard from "../common/guard";
import { IQueues } from "../models/applicationState";
import {
    headers, createUserQueue, deleteUserQueue, userAllQueues, analyseResultEndPoint,deleteTestFiles,
    dataRevisionEndPoint, processBatchPredictionEndPoint, deleteFileEndPoint, accessToken, refreshTokenEndPoint, 
    refreshTokenCall, submitErrorProcess, getAllInvalidFiles, invoiceManagement, 
    documentMangement,getOrderManagementDetailsEndPoint,getOrderManagementDetailsEndPointByDate,
    documentMangementEndPointByDate,
    orderMgt_Lock_Apply_Endpoint,orderMgt_Lock_check_Endpoint,orderMgt_Lock_Release_Endpoint
} from "../common/api-config";
import ServiceHelper from "./serviceHelper";
import { toast } from "react-toastify";

export interface IUserOperationsService {
    createUserQueue(queueObject: any, payload: any): Promise<void>;
    userAllQueues(queueObject): Promise<void>;
    deleteUserQueue(queueObject): Promise<void>;
    processBatchPrediction(projectName: string, queueName: string): Promise<void>;
    dataRevisionJson(jsonObjectPayload: any, projectName: string): Promise<void>;
    deleteFile(projectName: string, queueName: string, fileName: string): Promise<void>;
    analyseFileResult(projectName: string, queueName: string, fileName: string): Promise<void>;
}

export default class UserOperationsService implements IUserOperationsService {
    /**
     * Create Queue
     */
    public createUserQueue = async (queueObject: any, payload: any) => {
        let response;
        let headers = accessToken()
        try {
            response = await ServiceHelper.postWithAutoRetry(
                createUserQueue(queueObject), payload, { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.postWithAutoRetry(
                            createUserQueue(queueObject), payload, { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }

    /*
    * Data Revision JSON
    */
    public dataRevisionJson = async (jsonObjectPayload: any, projectName) => {
        console.log(jsonObjectPayload, "***jsonObjectPayload***;");
        let response;
        let headers = accessToken()
        try {
            response = await ServiceHelper.postWithAutoRetry(
                dataRevisionEndPoint(projectName), jsonObjectPayload, { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.postWithAutoRetry(
                            dataRevisionEndPoint(projectName), jsonObjectPayload, { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }

    /**
     * Delete Queue
     */
    public deleteUserQueue = async (queueObject: IQueues) => {
        let response;
        let headers = accessToken()
        try {
            response = await ServiceHelper.getWithAutoRetry(
                deleteUserQueue(queueObject), { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            deleteUserQueue(queueObject), { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }

     /**
     * Delete test files
     */
    public deleteTestFiles = async (userid: string) => {
        let response;
        let headers = accessToken()
        try {
            response = await ServiceHelper.getWithAutoRetry(
                deleteTestFiles(userid), { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            deleteTestFiles(userid), { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }

    public getInValidFiles = async (fileType: string) => { 
        let response;
        let headers = accessToken()
        try {
            response = await ServiceHelper.getWithAutoRetry(
                getAllInvalidFiles(fileType), { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            getAllInvalidFiles(fileType), { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }

    public getInvoiceManagementFiles = async () => { 
        let response;
        let headers = accessToken()
        try {
            response = await ServiceHelper.getWithAutoRetry(
                invoiceManagement(), { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            invoiceManagement(), { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }

    public getDocumentManagementFiles = async () => { 
        let response;
        let headers = accessToken();
        try {
            response = await ServiceHelper.getWithAutoRetry(
                documentMangement(), { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            documentMangement(), { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }
    
    
    public getDocumentManagementFilesbyDate = async (fromdate:string, todate:string) => { 
        let response;
        let headers = accessToken();
        try {
            response = await ServiceHelper.getWithAutoRetry(
                documentMangementEndPointByDate(fromdate, todate), { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            documentMangement(), { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }
    
    public getOrderManagementFiles = async () => { 
        let response;
        let headers = accessToken();
        try {
            response = await ServiceHelper.getWithAutoRetry(
                getOrderManagementDetailsEndPoint(), { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            documentMangement(), { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }

    
    public getOrderManagementFilesbyDate = async (fromdate:string, todate:string) => { 
        let response;
        let headers = accessToken();
        try {
            response = await ServiceHelper.getWithAutoRetry(
                getOrderManagementDetailsEndPointByDate(fromdate,todate), { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            documentMangement(), { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }


    public submitError = async (projectName:String,fileType: string) => { 
        let response;
        let headers = accessToken()
        try {
            response = await ServiceHelper.getWithAutoRetry(
                submitErrorProcess(projectName,fileType), { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            submitErrorProcess(projectName,fileType), { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }



    /**
     * Get All User Queues
     */
    public userAllQueues = async (projectName: string) => {
        let response;
        let headers = accessToken()
        try {
            response = await ServiceHelper.getWithAutoRetry(
                userAllQueues(projectName), { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            userAllQueues(projectName), { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }

    /**
     * Batch Prediction
     */
    public processBatchPrediction = async (projectName: string, queueName: string) => {
        let response;
        let headers = accessToken()
        try {
            response = await ServiceHelper.getWithAutoRetry(
                processBatchPredictionEndPoint(projectName, queueName), { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            processBatchPredictionEndPoint(projectName, queueName), { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }

    /**
     * Delete File
     */
    public deleteFile = async (projectName: string, queueName: string, fileName: string) => {
        let response;
        let headers = accessToken()
        try {
            response = await ServiceHelper.getWithAutoRetry(
                deleteFileEndPoint(projectName, queueName, fileName), { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            deleteFileEndPoint(projectName, queueName, fileName), { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }

    /**
     * Analyse File Result
     */
    public analyseFileResult = async (projectName: string, queueName: string, fileName: string) => {
        let response;
        let headers = accessToken()
        try {
            response = await ServiceHelper.getWithAutoRetry(
                analyseResultEndPoint(projectName, queueName, fileName), { headers });
            return response;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            analyseResultEndPoint(projectName, queueName, fileName), { headers });
                        return response;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }

    
    public orderMgt_CheckLock = async (reqDetailsId: string, rowkey:string, keyword:string) => {
        let response;
        let headers = accessToken();
        try {
          
            if(keyword == "check")
            {          
            
            response = await ServiceHelper.getWithAutoRetry(
                orderMgt_Lock_check_Endpoint(reqDetailsId, rowkey, keyword), { headers });
            }
            else  if(keyword == "relive")
            {
                response = await ServiceHelper.getWithAutoRetry(
                    orderMgt_Lock_Release_Endpoint(reqDetailsId, rowkey,"relieve"), { headers });
            }
            
            else  if(keyword == "apply")
            {
                response = await ServiceHelper.getWithAutoRetry(
                    orderMgt_Lock_Apply_Endpoint(reqDetailsId, rowkey), { headers });
            }
            else
            {
                
            }
            return response;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            orderMgt_Lock_Release_Endpoint(reqDetailsId, rowkey, keyword), { headers });
                        return response;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }
    
}

